import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FeedManager } from '../shared/feed-manager.service';
import { SearchSpecification } from '../shared/models/search-specification.model';
import * as FileSaver from 'file-saver';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';

@Component({
  selector: 'dm-feed-download-link',
  templateUrl: './feed-download-link.component.html',
  styleUrls: ['./feed-download-link.component.css']
})
export class FeedDownloadLinkComponent {
    @Input() feedName: string;
    @Input() format: string;
    @Input() label: string;
    @Input() outboundIsArchive: boolean;
    @Input() searchSpecification: SearchSpecification;
    @Output() removeError = new EventEmitter();
    @Output() submitError = new EventEmitter<any>();

    initialized = true;
    errorKey = 'feed-download-link';

    constructor(private feedManager: FeedManager, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) { }

    getLink(): any {
        this.initialized = false;
        this.clearError();
        this.removeError.emit();

        const linkForExport = this.feedManager.getLinkForExport(this.feedName, this.searchSpecification, this.format, this.outboundIsArchive);
        if (linkForExport) {
            linkForExport.subscribe(
                result => {
                    const blob = new Blob([result], { type: 'text/csv' });
                    FileSaver.saveAs(blob, `${this.feedName}.csv`);
                    this.initialized = true;
                },
                error => {
                    this.initialized = true;
                    this.submitError.emit(error);
                    this.handleError(error);
                }
            );
        }

        return;
    }

    clearError() {
        this.errorManager.removeDataMinerUiError(this.errorManager.errorExploreDataSetKey, this.errorKey);
    }

    handleError(error: any) {
        const FeedDownloadLinkNoResponse = 'An unexpected error occurred. Please try again.';
        this.errorManager.saveDataMinerUiError(this.errorManager.errorExploreDataSetKey, this.errorKey, error, FeedDownloadLinkNoResponse);
        this.eventLogger.logError(new Error(this.errorManager.dataMinerUiError.message), this.errorManager.dataMinerUiError.message, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-download-link/feed-download-link.component.ts